var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHebrew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2475C0 17.4056 0.93882 18.3445 2.09699 18.3445H25.903C27.0611 18.3445 28 17.4057 28 16.2475V14.4824H0V16.2475Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.903 0H2.09699C0.93882 0 0 0.93882 0 2.09699V3.86209H28V2.09699C28 0.93882 27.0612 0 25.903 0Z",
    fill: "#41479B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 3.37891H0V14.965H27.9999V3.37891Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5083 9.17293L17.7625 7.00069H15.2542L13.9999 4.82812L12.7455 7.00069H10.2373L11.4915 9.17293L10.2373 11.3452H12.7455L13.9999 13.5177L15.2542 11.3452H17.7624L16.5083 9.17293ZM16.532 7.71113L16.0982 8.46254L15.6643 7.71113H16.532ZM15.688 9.17293L14.844 10.6347H13.1556L12.3117 9.17293L13.1557 7.71113H14.8441L15.688 9.17293ZM13.9999 6.24901L14.4339 7.00075H13.5659L13.9999 6.24901ZM11.4677 7.71113H12.3353L11.9015 8.46254L11.4677 7.71113ZM11.4677 10.6347L11.9016 9.88332L12.3354 10.6347H11.4677ZM13.9999 12.0968L13.5659 11.3451H14.4339L13.9999 12.0968ZM16.0982 9.88332L16.532 10.6347H15.6644L16.0982 9.88332Z",
    fill: "#41479B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHebrew);
export default __webpack_public_path__ + "static/media/hebrew.bc6c94e0.svg";
export { ForwardRef as ReactComponent };